/**
 * Function that takes a number and returns it formatted in CL
 * @returns {number}
 */
export function formatPriceToAR(price) {
    return price.toLocaleString("es-AR", {
        style: "currency",
        currency: "ARS",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function formatPrice(price, currency = "ARS", locale = "es", defaultValue = 0) {
    if (price === undefined || price === null) {
        if (defaultValue === 0) price = defaultValue;
        else return defaultValue;
    }
    return price.toLocaleString(locale === "en" ? "en-US" : "es-AR", {
        style: "currency",
        currency: currency,
        currencyDisplay: "code",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function formatNumber(num, locale = "es", decimalSteps = 2) {
    if (num === undefined || num === null) {
        num = 0;
    }

    const thousands = locale === "en" ? "," : ".";
    const decimals = locale === "en" ? "." : ",";
    const [integerPart, decimalPart] = num?.toString().split(".");

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    let formattedNumber = formattedInteger;
    if (decimalPart) {
        if (decimalSteps > 0) {
            formattedNumber += decimals + decimalPart.slice(0, decimalSteps);
        } else {
            formattedNumber += decimals + decimalPart;
        }
    }

    return formattedNumber;
}

/**
 * Create an array of options for the autocomplete component
 * @param {*} searchItems
 * @returns formatted search items
 */
export function createAutoCompleteOptions(searchItems, productTypeFilter = null) {
    if (!searchItems) {
        console.log("No search items found, empty array returned");
        return [];
    }

    if (productTypeFilter) {
        return searchItems
            .filter((item) => item.type === productTypeFilter)
            .map((item, i) => ({
                key: i,
                type: item.type,
                code: item.code,
                isFondo: item.type === "fondos",
                id: item.id,
                value: `${item.description || ""} ${item.code || ""}`,
                // label: `${item.code} - ${item.type} - ${i}`,
                label: `${item.code}`,
            }));
    }

    return searchItems.map((item, i) => ({
        key: i,
        type: item.type,
        code: item.code,
        isFondo: item.type === "fondos",
        id: item.id,
        value: `${item.description || ""} ${item.code || ""}`,
        // label: `${item.code} - ${item.type} - ${i}`,
        label: `${item.code}`,
    }));
}

// Función para procesar los datos de la API y prepararlos para el gráfico
export function processChartData(apiData) {
    const xAxisData = apiData.map((item) => {
        // Ajusta la hora a tu necesidad específica
        const time = item.horaOperacion.split(".")[0];
        return time;
    });

    const seriesData = apiData.map((item) => item.montoOperado);

    return {
        xAxisData,
        seriesData,
    };
}

export function setTheme(theme = "dark", headerClass = ".header") {
    const headerEls = document.querySelectorAll(headerClass);

    if (headerEls) {
        headerEls.forEach((headerEl) => {
            headerEl.classList.add(`--theme-${theme}`);
        });
    }
}

export function parsePercentaje(number) {
    // Redondeamos hacia arriba y convertimos a porcentaje
    const numberToParse = number;
    // Retornamos el número como string con dos decimales
    return `${numberToParse.toFixed(2)}%`;
}

export const processDetailInstrumentChartData = (apiData, type = "precio") => {
    if (!apiData) {
        return { xAxisData: [], seriesData: [] };
    }
    // Asegúrate de que apiData es el arreglo de objetos que quieres graficar
    const xAxisData = apiData.map((item) => item.fecha);
    const seriesData = apiData.map((item) => item[type]);

    return { xAxisData, seriesData };
};
